// extracted by mini-css-extract-plugin
module.exports = {"aboutSeo":"AboutSeo_aboutSeo__pXM-2","Title":"AboutSeo_Title__2AIMP","List":"AboutSeo_List__1hmaB","Item":"AboutSeo_Item__14ZHq","CirclePink":"AboutSeo_CirclePink__3GP1h"};